import { useState } from "react";

import { Button, Input } from "@/components/ui";
import { useFolderLeaves } from "@/hooks/useFolderLeaves";

import { LeafRadioList } from "./LeafRadioList";
import { byP } from "./leafOptions";
import type { PickProps, ReviewOption } from "./LeafTabs.types";

export function ExistingLeavesTab({
  options,
  folder,
  enginePick,
  picked,
  onPick,
}: PickProps & {
  options: ReviewOption[];
  folder: string | null;
  enginePick: string | null;
}) {
  const [text, setText] = useState("");
  const [searchAll, setSearchAll] = useState(false);
  const folderLeaves = useFolderLeaves(text, folder, searchAll);
  const needle = text.trim().toLowerCase();
  const shown = searchAll
    ? folderLeaves
    : options
        .filter(
          (o) =>
            o.existing &&
            `${o.key} ${o.description ?? ""}`.toLowerCase().includes(needle),
        )
        .sort(byP);
  return (
    <div className="space-y-2 p-3">
      <div className="flex gap-2">
        <Input
          aria-label="Filter leaves"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <Button
          variant="outline"
          disabled={!folder}
          onClick={() => setSearchAll(true)}
        >
          Search all in this folder
        </Button>
      </div>
      <LeafRadioList
        options={shown}
        enginePick={enginePick}
        picked={picked}
        onPick={onPick}
      />
    </div>
  );
}
